export default __webpack_public_path__ + "static/media/BG-LightBlue-0004.9f91f69d.png";